<template>
    <div class="relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot">
        <div class="flex flex-1 lg:flex-row flex-col">
            <SidebarSection>
                <LabelControl type="message" :content="$t('qrc001')" />
            </SidebarSection>
            <ContentSection :show_logout="false">
                <div class="flex flex-col">
                    <LabelControl class="mb-8" type="heading" :content="$t('qrc002')" />

                    <div class="papsi-scanner rounded-xl overflow-hidden">
                        <QRCodeReaderControl @decoded="validate" />
                    </div>

                </div>
            </ContentSection>
        </div>
        <FooterSection />
    </div>
</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import mixin from '@/mixins/controls.js';
import LabelControl from '@/components/controls/LabelControl.vue';
import QRCodeReaderControl from '@/components/controls/QRCodeReaderControl.vue';

import user from '@/services/user';

export default {
    mixins: [mixin],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
        QRCodeReaderControl
    },
    data() {
        return {
            qr: null,
            inactivity_timeout: null,
        };
    },
    inject: ['setLoading', 'setError'],
    mounted() {
        this.$emit('checkauth', false);
        this.startInactivityTimer();
        window.addEventListener("touchstart", this.resetInactivityTimer);
    },
    beforeUnmount() {
        clearTimeout(this.inactivity_timeout);
        window.removeEventListener("touchstart", this.resetInactivityTimer);
    },
    methods: {
        resetInactivityTimer() {
            clearTimeout(this.inactivity_timeout);
            this.startInactivityTimer();
        },
        startInactivityTimer() {
            if (process.env.VUE_APP_DEVELOPMENT_MODE === 'false') {
                this.inactivity_timeout = setTimeout(() => {
                this.$router.push({ name: "start-page" });
                }, process.env.VUE_APP_IDLE_DELAY || 30000);
            } 
        },
        validate(qr) {
            this.setLoading(true);
            user.validateQR(qr, 2)
                .then((response) => {
                    const hash = response.data.data.hash;
                    const uuid = response.data.data.uuid;
                    this.setLoading(false);
                    this.$store.commit('setLoginParams', { hash, value: qr, uuid, type: 'qr' });
                    this.$router.push({ name: 'enter-pin-page' });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        this.savePINEnrollee(error.response.data.data, qr, 2);
                        this.$router.push({ name: 'enroll-pin-page' });
                    } else {
                        this.showError(error.response.data.message);
                    }
                    this.setLoading(false);
                });
        },
    }



};
</script>


<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}

.papsi-scanner {
    height: 40rem;
}

@media (min-width: 2500px) {
    .papsi-scanner {height: 67rem;}
}
</style>
